import { NgClass } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DynamicFormViewerComponent } from '../../dynamic-form-viewer';
import { DynamicFormDTO } from '../../models';
import { FormMode } from '../../models/form-mode.enum';
import { DynamicFormViewerService } from '../../services/viewer.service';

@Component({
   
  imports: [DynamicFormViewerComponent, MatButton, MatIcon, NgClass],
  selector: 'siat-preview-container',
  providers: [DynamicFormViewerService],
  template: ` <siat-dynamic-form-viewer
      [formMode]="formMode"
      [dynamicFormDto]="dynamicFormDto()"
    ></siat-dynamic-form-viewer>
    <div class="mt-6 border-t pt-4">
      <div
        class="flex items-center justify-between p-3 rounded-lg transition-all duration-300"
        [ngClass]="
          form()?.valid
            ? 'bg-green-50 border border-green-200'
            : 'bg-amber-50 border border-amber-200'
        "
      >
        <div class="flex items-center gap-3">
          <div>
            <mat-icon
              [class]="form()?.valid ? 'text-green-600' : 'text-amber-600'"
            >
              {{ form()?.valid ? 'check_circle' : 'info' }}
            </mat-icon>
          </div>
          <div class="flex flex-col">
            <span
              class="text-sm font-semibold"
              [class]="form()?.valid ? 'text-green-900' : 'text-amber-900'"
            >
              {{ form()?.valid ? 'Form Valido' : 'Form non ancora valido' }}
            </span>
            <p class="text-xs  mt-2 italic ">
              * Questa è una simulazione. Il pulsante di salvataggio è
              disabilitato in modalità anteprima.
            </p>
          </div>
        </div>
        <button
          matButton="tonal"
          [disabled]="!form()?.valid"
          class="pointer-events-none"
          type="button"
        >
          <mat-icon class="mr-2">save</mat-icon>
          Salva
        </button>
      </div>
    </div>`,
})
export class PreviewContainerComponent {
  /**
   * The form mode.
   */
  formMode = FormMode.Preview;

  /**
   * The dynamic form dto.
   */
  dynamicFormDto = input.required<DynamicFormDTO>();

  /**
   * The viewer service.
   */
  viewerService = inject(DynamicFormViewerService);

  /**
   * The form.
   */
  form = this.viewerService.formGroup;
}
